import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import {setPullablePartDragging} from 'actions/index.js';

const PullablePart = (props) => { 
    const onDragStart = useCallback((e) => {
        let {effect, instrument} = props;
        let part = {
            instrument,
            effect,
            id: props.id || (instrument || effect).id,
            type: props.type
        };
        if (instrument && instrument.track) {
            part.track = instrument.track;
        } else if (effect) {
            part.track = effect.track;
        }
        props.setPullablePartDragging(part);
    }, []);
 
    return (
        <div
          onMouseDown={(e) => {
              if (props.isDraggable) {
                  e.stopPropagation();
              }
          }}
          draggable={props.isDraggable ? "true" : "false"}
          onDragStart={onDragStart}
          onDragOver={(e) => {
              e.preventDefault();
          }}
          className={props.className}
          {...props}
        >
        {!props.skipDiv ? 
          <div>
            {props.children}
         </div> :
         props.children}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setPullablePartDragging: x => dispatch(setPullablePartDragging(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PullablePart);
